export function stringToBoolean(value) {
  if (typeof value !== 'string') {
    return Boolean(value);
  }

  const normalizedValue = value.toLowerCase().trim();

  return normalizedValue === 'true';
}
